import Dashboard from "./views/Dashboard";
import SetOff from "./views/ESetOff/SetOff";
import EPayment from "./views/EPayment";
import PaymentDetail from "./views/EPayment/PaymentDetail";
import ManualTransfer from "./views/EPayment/ManualTransfer";
import FPXTransfer from "./views/EPayment/FPXTransfer";
import PaymentSuccessful from "./views/EPayment/PaymentSuccessful";
import TransactionHistory from "./views/EDeposit/TransactionHistory";
import ESettlement from "./views/ESettlement";
import DailyBusinessReport from "./views/DailyBusinessReport";
import MarginSimulator from "./views/ESettlement/MarginSimulator";
import MarginStatement from "./views/ESettlement/MarginStatement";
import ESetOff from "./views/ESetOff";
import EDeposit from "./views/EDeposit";
import DepositFPXTransfer from "./views/EDeposit/DepositOnlineFPX";
import DepositManual from "./views/EDeposit/DepositManual";
import DepositRedirectSuccess from "./views/EDeposit/RedirectSuccessful";
import DepositRedirectFailed from "./views/EDeposit/RedirectFailure";
import EWithdraw from "./views/EWithdraw";
import EWithdrawHistory from "./views/EWithdraw/EWithdrawHistory";
import ProfitAndLossCalculator from "./views/ESettlement/ProfitAndLossCalculator";
import PaymentHistory from "./views/EPayment/PaymentHistory";
import CashWithdrawal from "./views/EWithdraw/CashWithdrawal";
import UserGuide from "./views/UserGuide";
import SetOffUserGuide from "./views/UserGuide/SetOffGuide";
import PaymentUserGuide from "./views/UserGuide/PaymentGuide";
import WithdrawUserGuide from "./views/UserGuide/WithdrawGuide";
import DepositUserGuide from "./views/UserGuide/DepositGuide";
import SetOffHistory from "./views/ESetOff/SetOffHistory";
import ActivityLog from "./views/ActivityLog";
import Profile from "./views/Profile";
import EIPO from "./views/EIPO";
import EIPOSubscribe from "./views/EIPOSubscribe";

export const eIPORoutes = [
  {
    path: "/dashboard/e-ipo",
    name: "E-IPO",
    // icon: "nc-icon nc-bell-55",
    component: EIPO,
  },

]

const dashboardRoutes = [
  {
    path: "/dashboard/withdraw-history",
    name: "Deposit Redirect Successful",
    // icon: "nc-icon nc-bell-55",
    component: EWithdrawHistory,
    isShowClientInfo:true
  },
  {
    path: "/dashboard/deposit/callback",
    name: "Deposit Redirect Successful",
    // icon: "nc-icon nc-bell-55",
    component: DepositRedirectSuccess,
  },
  {
    path: "/dashboard/payment-transaction-failed",
    name: "Deposit Redirect Failed",
    // icon: "nc-icon nc-bell-55",
    component: DepositRedirectFailed,
  },
  {
    path: "/dashboard/deposit-manual",
    name: "Deposit Manual",
    // icon: "nc-icon nc-bell-55",
    component: DepositManual,
    isNotSwitchable:true

  },
  {
    path: "/dashboard/deposit-fpx-transfer",
    name: "Deposit FPX Transfer",
    // icon: "nc-icon nc-bell-55",
    component: DepositFPXTransfer,
      isNotSwitchable:true

  },
  {
    path: "/dashboard/e-deposit",
    name: "E Deposit",
    // icon: "nc-icon nc-bell-55",
    component: EDeposit,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/margin-statement",
    name: "Margin Statement",
    // icon: "nc-icon nc-bell-55",
    component: MarginStatement,
    isShowClientInfo:true

  },
  // {
  //   path: "/dashboard/margin-calculator",
  //   name: "Margin Calculator",
  //   // icon: "nc-icon nc-bell-55",
  //   component: MarginSimulator,
  // },
  {
    path: "/dashboard/daily-business-done",
    name: "Daily Business Done",
    // icon: "nc-icon nc-bell-55",
    component: DailyBusinessReport,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/outstanding-statement",
    name: "E Settlement",
    // icon: "nc-icon nc-bell-55",
    component: ESettlement,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/transaction-history",
    name: "Transaction History",
    // icon: "nc-icon nc-bell-55",
    component: TransactionHistory,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/payment/callback",
    name: "Payment Successful",
    // icon: "nc-icon nc-bell-55",
    component: PaymentSuccessful,
  },
  {
    path: "/dashboard/payment/fpx-transfer",
    name: "FPX Transfer",
    // icon: "nc-icon nc-bell-55",
    component: FPXTransfer,
    isNotSwitchable:true

  },
  {
    path: "/dashboard/payment/manual-transfer",
    name: "Manual Transfer",
    // icon: "nc-icon nc-bell-55",
    component: ManualTransfer,
    isNotSwitchable:true

  },
  {
    path: "/dashboard/payment/history",
    name: "Payment History",
    // icon: "nc-icon nc-bell-55",
    component: PaymentHistory,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/payment/detail",
    name: "Payment Detail",
    // icon: "nc-icon nc-bell-55",
    component: PaymentDetail,
    isNotSwitchable:true

  },
  {
    path: "/dashboard/payment",
    name: "E Payment",
    // icon: "nc-icon nc-bell-55",
    component: EPayment,
    isNotSwitchable:true,
    isShowClientInfo:true


  },
  {
    path: "/dashboard/set-off",
    name: "Setoff",
    isShowClientInfo:true,
    // icon: "nc-icon nc-bell-55",
    component: SetOff,
  },
  {
    path: "/dashboard/set-off/history",
    name: "Setoff History",
    // icon: "nc-icon nc-bell-55",
    component: SetOffHistory,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/withdraw",
    name: "Withdraw",
    // icon: "nc-icon nc-bell-55",
    component: EWithdraw,
    isNotSwitchable:true,
    isShowClientInfo:true


  },
  // {
  //   path: "/dashboard/statement-summary",
  //   name: "Statement Summary",
  //   // icon: "nc-icon nc-bell-55",
  //   component: ESetOff,
  //   isShowClientInfo:true
  // },
  {
    path: "/dashboard/p-and-l-calculator",
    name: "Profit And Loss Calculator",
    // icon: "nc-icon nc-bell-55",
    component: ProfitAndLossCalculator,
    isShowClientInfo:true

  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // icon: "nc-icon nc-bell-55",
    component: Dashboard,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/cash-withdrawal",
    name: "Cash Withdrawal",
    // icon: "nc-icon nc-bell-55",
    component: CashWithdrawal,
    isNotSwitchable:true,

  },
  {
    path: "/dashboard/user-guide",
    name: "User Guide",
    // icon: "nc-icon nc-bell-55",
    component: UserGuide,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/user-guide/set-off-guide",
    name: "e-Setoff User Guide",
    // icon: "nc-icon nc-bell-55",
    component: SetOffUserGuide,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/user-guide/payment-guide",
    name: "e-Payment User Guide",
    // icon: "nc-icon nc-bell-55",
    component: PaymentUserGuide,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/user-guide/withdraw-guide",
    name: "e-Withdrawal User Guide",
    // icon: "nc-icon nc-bell-55",
    component: WithdrawUserGuide,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/user-guide/deposit-guide",
    name: "e-Deposit User Guide",
    // icon: "nc-icon nc-bell-55",
    component: DepositUserGuide,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/activity-log",
    name: "Activity Log",
    // icon: "nc-icon nc-bell-55",
    component: ActivityLog,
    isShowClientInfo:true

  },
  {
    path: "/dashboard/profile",
    name: "Profile",
    // icon: "nc-icon nc-bell-55",
    component: Profile
  },
];

export default dashboardRoutes;
